import React, { FunctionComponent } from 'react';
import './PanelWithButton.scss';

type PanelWithButtonProps = {
    id: string;
    buttonText: string;
    onButtonClick: () => void;
    children?: React.ReactNode;
};

const PanelWithButton: FunctionComponent<PanelWithButtonProps> = ({
    id,
    buttonText,
    onButtonClick,
    children
}) => {
    return (
        <div id={id} className='button-div-container'>
            <div className='options-container'>{children}</div>
            <div className='button-container'>
                <button className='btn btn-primary' onClick={onButtonClick}>
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

export default PanelWithButton;
